import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { SpanTooltipComponent } from "../../../shared/components/span-tooltip/span-tooltip.component";
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';

@Component({
    selector: 'states-task-help-modal',
    templateUrl: './states-task-help-modal.component.html',
    standalone: true,
    imports: [SpanTooltipComponent, AfTranslateDirective, AfTranslatePipe]
})
export class StatesTaskHelpModalComponent {
  constructor(private dialogRef: DynamicDialogRef<StatesTaskHelpModalComponent>) { }

  handleDismiss(){
    this.dialogRef.close({result: 'cancel'});
  }
}
